import {apsCommands} from "../../shared/dto/aps.commands";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface JobChangeService {
  addJobChange(addJobChangeCommand: apsCommands.AddJobChange): angular.IPromise<any>;
}

class JobChangeSvc implements JobChangeService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  addJobChange(addJobChangeCommand: apsCommands.AddJobChange) {
    return this.httpService.put(Endpoints.JOB_CHANGE_ADD, addJobChangeCommand);
  }
}

export default angular
  .module('aps.services.jobChange', [HttpServiceName])
  .service('jobChangeService', JobChangeSvc)
  .name;



// WEBPACK FOOTER //
// ./src/app/services/jobChange/jobChange.service.ts